// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaUpload_root__zNfl4 {
  background-color: #f2f2f2;
  height: 316px;
  width: 100%;
}
.MediaUpload_root__zNfl4 > div.MediaUpload_hide__Ex74d {
  display: none;
}
.MediaUpload_root__zNfl4 .MediaUpload_uploader__tiEqp {
  border: dashed 1px #dedede;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.MediaUpload_root__zNfl4 .MediaUpload_uploader__tiEqp .MediaUpload_files__H1lAS {
  flex: 1 1;
  padding: 16px 24px 0;
}
.MediaUpload_root__zNfl4 .MediaUpload_uploader__tiEqp .MediaUpload_files__H1lAS > :not(:first-child) {
  border-top: solid 1px #dedede;
}
.MediaUpload_root__zNfl4 .MediaUpload_uploader__tiEqp .MediaUpload_actions__89pW9 {
  background-color: white;
  display: flex;
  flex-direction: row-reverse;
  padding: 8px 16px;
  gap: 8px;
}

.MediaUpload_selector__TVm00 {
  border: dashed 1px #dedede;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 34px;
}
.MediaUpload_selector__TVm00.MediaUpload_drag__-Jewh {
  background-color: #e1f5fd;
}
.MediaUpload_selector__TVm00 .MediaUpload_content__mN0Th {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.MediaUpload_selector__TVm00 .MediaUpload_content__mN0Th .MediaUpload_title__1T7dM {
  letter-spacing: 0.1px;
  color: #111;
}
.MediaUpload_selector__TVm00 .MediaUpload_content__mN0Th .MediaUpload_title__1T7dM svg {
  margin-right: 8px;
}
.MediaUpload_selector__TVm00 .MediaUpload_content__mN0Th input {
  visibility: hidden;
  position: absolute;
}
.MediaUpload_selector__TVm00 .MediaUpload_notice__1yX1d {
  font-size: 12px;
  letter-spacing: 0.3px;
  text-align: center;
  color: rgba(17, 17, 17, 0.7019607843);
}
.MediaUpload_selector__TVm00 .MediaUpload_notice__1yX1d svg {
  color: #b6b6b6;
}

.MediaUpload_row__gqWe1 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.MediaUpload_row__gqWe1 .MediaUpload_nameBlock__5dJ4u {
  flex: 1 1;
  font-size: 13px;
  letter-spacing: 0.1px;
  color: #111;
}
.MediaUpload_row__gqWe1 .MediaUpload_nameBlock__5dJ4u .MediaUpload_details__Xk5zQ {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
.MediaUpload_row__gqWe1.MediaUpload_selected__nEGWc .MediaUpload_nameBlock__5dJ4u {
  font-size: 15px;
}
.MediaUpload_row__gqWe1 .MediaUpload_status__QvBHx {
  display: flex;
  text-transform: capitalize;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.MediaUpload_row__gqWe1 .MediaUpload_status__QvBHx .MediaUpload_text__rVz4C {
  flex: 1 1;
}
.MediaUpload_row__gqWe1 .MediaUpload_status__QvBHx.MediaUpload_completed__tngn\\+ {
  color: #28a745;
}
.MediaUpload_row__gqWe1 .MediaUpload_status__QvBHx.MediaUpload_uploading__bFonP {
  color: #878787;
}
.MediaUpload_row__gqWe1 .MediaUpload_status__QvBHx.MediaUpload_failed__B40Pz {
  color: #e64949;
}
.MediaUpload_row__gqWe1 .MediaUpload_status__QvBHx svg.MediaUpload_retry__OPAjo {
  color: #878787;
  cursor: pointer;
}
.MediaUpload_row__gqWe1 .MediaUpload_rowActions__6KgME {
  width: 64px;
  text-align: end;
}
.MediaUpload_row__gqWe1 .MediaUpload_rowActions__6KgME svg {
  cursor: pointer;
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/MediaUpload/MediaUpload.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,WAAA;AACF;AAAE;EACE,aAAA;AAEJ;AACE;EACE,0BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACJ;AAAI;EACE,SAAA;EACA,oBAAA;AAEN;AADM;EACE,6BAAA;AAGR;AAAI;EACE,uBAAA;EACA,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,QAAA;AAEN;;AAGA;EACE,0BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAAF;AACE;EACE,yBAAA;AACJ;AACE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AACJ;AAAI;EACE,qBAAA;EACA,WAAA;AAEN;AADM;EACE,iBAAA;AAGR;AAAI;EACE,kBAAA;EACA,kBAAA;AAEN;AACE;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,qCAAA;AACJ;AAAI;EACE,cAAA;AAEN;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;AACE;EACE,SAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AACJ;AAAI;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AAEN;AACE;EACE,eAAA;AACJ;AACE;EACE,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,qBAAA;AACJ;AAAI;EACE,SAAA;AAEN;AAAI;EACE,cAAA;AAEN;AAAI;EACE,cAAA;AAEN;AAAI;EACE,cAAA;AAEN;AAAI;EACE,cAAA;EACA,eAAA;AAEN;AACE;EACE,WAAA;EACA,eAAA;AACJ;AAAI;EACE,eAAA;EACA,gBAAA;AAEN","sourcesContent":[".root {\r\n  background-color: #f2f2f2;\r\n  height: 316px;\r\n  width: 100%;\r\n  > div.hide {\r\n    display: none;\r\n  }\r\n\r\n  .uploader {\r\n    border: dashed 1px #dedede;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    .files {\r\n      flex: 1;\r\n      padding: 16px 24px 0;\r\n      > :not(:first-child) {\r\n        border-top: solid 1px #dedede;\r\n      }\r\n    }\r\n    .actions {\r\n      background-color: white;\r\n      display: flex;\r\n      flex-direction: row-reverse;\r\n      padding: 8px 16px;\r\n      gap: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.selector {\r\n  border: dashed 1px #dedede;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  padding: 34px;\r\n  &.drag {\r\n    background-color: #e1f5fd;\r\n  }\r\n  .content {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 8px;\r\n    .title {\r\n      letter-spacing: 0.1px;\r\n      color: #111;\r\n      svg {\r\n        margin-right: 8px;\r\n      }\r\n    }\r\n    input {\r\n      visibility: hidden;\r\n      position: absolute;\r\n    }\r\n  }\r\n  .notice {\r\n    font-size: 12px;\r\n    letter-spacing: 0.3px;\r\n    text-align: center;\r\n    color: #111111b3;\r\n    svg {\r\n      color: #b6b6b6;\r\n    }\r\n  }\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  .nameBlock {\r\n    flex: 1;\r\n    font-size: 13px;\r\n    letter-spacing: 0.1px;\r\n    color: #111;\r\n    .details {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      margin-bottom: 4px;\r\n    }\r\n  }\r\n  &.selected .nameBlock {\r\n    font-size: 15px;\r\n  }\r\n  .status {\r\n    display: flex;\r\n    text-transform: capitalize;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 12px;\r\n    letter-spacing: 0.3px;\r\n    .text {\r\n      flex: 1;\r\n    }\r\n    &.completed {\r\n      color: #28a745;\r\n    }\r\n    &.uploading {\r\n      color: #878787;\r\n    }\r\n    &.failed {\r\n      color: #e64949;\r\n    }\r\n    svg.retry {\r\n      color: #878787;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n  .rowActions {\r\n    width: 64px;\r\n    text-align: end;\r\n    svg {\r\n      cursor: pointer;\r\n      margin-left: 4px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MediaUpload_root__zNfl4`,
	"hide": `MediaUpload_hide__Ex74d`,
	"uploader": `MediaUpload_uploader__tiEqp`,
	"files": `MediaUpload_files__H1lAS`,
	"actions": `MediaUpload_actions__89pW9`,
	"selector": `MediaUpload_selector__TVm00`,
	"drag": `MediaUpload_drag__-Jewh`,
	"content": `MediaUpload_content__mN0Th`,
	"title": `MediaUpload_title__1T7dM`,
	"notice": `MediaUpload_notice__1yX1d`,
	"row": `MediaUpload_row__gqWe1`,
	"nameBlock": `MediaUpload_nameBlock__5dJ4u`,
	"details": `MediaUpload_details__Xk5zQ`,
	"selected": `MediaUpload_selected__nEGWc`,
	"status": `MediaUpload_status__QvBHx`,
	"text": `MediaUpload_text__rVz4C`,
	"completed": `MediaUpload_completed__tngn+`,
	"uploading": `MediaUpload_uploading__bFonP`,
	"failed": `MediaUpload_failed__B40Pz`,
	"retry": `MediaUpload_retry__OPAjo`,
	"rowActions": `MediaUpload_rowActions__6KgME`
};
export default ___CSS_LOADER_EXPORT___;
